export default __webpack_public_path__ + "static/media/banner1.3c0b14a5.jpg";